import React, { Component } from "react";
import c from "classnames";
import { CSSTransition } from "react-transition-group";
import styles from "./style.module.scss";
import Translator from "components/Translator";
import Paragraph from "components/Paragraph";
import FormField from "./FormField";

const fieldsBySections = [
  {
    withFieldset: true,
    fields: [
      {
        col: 6,
        label: "v2_contacts-field-1",
        labelInline: false,
        name: "FNAME",
        type: "text",
        placeholder: "v2_contacts-field-1-default",
        validationFunction: v => v !== "",
        groupID: "merge_fields",
        defaultValue: ""
      },
      {
        col: 6,
        label: "v2_contacts-field-2",
        labelInline: false,
        name: "LNAME",
        type: "text",
        placeholder: "v2_contacts-field-2-default",
        validationFunction: v => v !== "",
        groupID: "merge_fields",
        defaultValue: ""
      },
      {
        col: 6,
        label: "v2_contacts-field-3",
        labelInline: false,
        name: "email_address",
        type: "email",
        placeholder: "v2_contacts-field-3-default",
        validationFunction: v =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ),
        groupID: null,
        defaultValue: ""
      },
      {
        col: 6,
        label: "v2_contacts-field-4",
        labelInline: false,
        name: "USER_TYPE",
        type: "select",
        options: [
          { value: "company", label: "v2_contacts-field-4-option1" },
          { value: "student", label: "v2_contacts-field-4-option2" },
          { value: "freelancer", label: "v2_contacts-field-4-option3" }
        ],
        placeholder: "v2_contacts-field-4-default",
        validationFunction: Boolean,
        groupID: "merge_fields",
        defaultValue: null
      },
      {
        col: 6,
        label: "v2_contacts-field-5",
        labelInline: false,
        name: "PURPOSE",
        type: "select",
        options: [
          { value: "info", label: "v2_contacts-field-5-option1" },
          { value: "partnership", label: "v2_contacts-field-5-option2" },
          { value: "investor", label: "v2_contacts-field-5-option3" },
          { value: "research", label: "v2_contacts-field-5-option4" },
          { value: "journalist", label: "v2_contacts-field-5-option5" },
          { value: "other", label: "v2_contacts-field-5-option6" }
        ],
        placeholder: "v2_contacts-field-5-default",
        validationFunction: Boolean,
        groupID: "merge_fields",
        defaultValue: null
      },
      {
        col: 12,
        label: "v2_contacts-field-6",
        labelInline: false,
        name: "MESSAGE",
        type: "textarea",
        placeholder: "v2_contacts-field-6-default",
        validationFunction: () => true,
        groupID: "merge_fields",
        defaultValue: ""
      }
    ]
  },
  {
    withFieldset: false,
    title: "v2_contacts-privacy-title",
    info: "v2_contacts-privacy"
  },
  {
    withFieldset: true,
    fields: [
      {
        col: 12,
        label: "v2_contacts-privacy-flag2",
        labelInline: true,
        name: "465a5abd52",
        type: "checkbox",
        validationFunction: () => true,
        groupID: "marketing_permissions",
        defaultValue: false
      },
      {
        col: 12,
        label: "v2_contacts-privacy-flag3",
        labelInline: true,
        name: "4176442427",
        type: "checkbox",
        validationFunction: () => true,
        groupID: "marketing_permissions",
        defaultValue: false
      }
    ]
  }
];

const formStatuses = {
  CLEAR: 0,
  INVALID: 1,
  VALID: 2,
  SUCCESS: 3,
  FORMAT_ERROR: 4,
  GENERIC_ERROR: 5
};

const fieldFlatList = fieldsBySections
  .filter(f => f.withFieldset)
  .map(f => f.fields)
  .reduce((a, f) => [...a, ...f], []);

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      invalid: true,
      formStatus: formStatuses.CLEAR,

      formData: fieldFlatList.reduce(
        (a, f) => ({
          ...a,
          [f.groupID || f.name]:
            f.groupID === null
              ? f.defaultValue
              : {
                  ...a[f.groupID],

                  [f.name]: f.defaultValue
                }
        }),
        {}
      ),
      validation: fieldFlatList.reduce(
        (a, f) => ({ ...a, [f.name]: f.validationFunction(f.defaultValue) }),
        {}
      )
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

    const { formData, validation } = this.state;

    const invalid = Object.values(validation).includes(false);

    if (invalid) {
      return false;
    }

    this.setState({ submitting: true });

    fetch("https://mwdeisl183.execute-api.eu-central-1.amazonaws.com/Test", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "x-api-key": "Mx85rSVDR964q1MdgXhT1aojksV4dJrW3E6VBPzt"
      }),
      body: JSON.stringify({
        ...formData,

        merge_fields: {
          ...formData.merge_fields,

          SOURCE: "iGenius_Contact"
        },

        marketing_permissions: Object.keys(formData.marketing_permissions).map(
          marketing_permission_id => ({
            marketing_permission_id,
            enabled: formData.marketing_permissions[marketing_permission_id]
          })
        ),
        status_if_new: "pending"
      })
    })
      .then(response => {
        if (response.status !== 200) {
          console.log("error", error);
          this.setState({
            formStatus: formStatuses.FORMAT_ERROR,
            submitting: false
          });
          return {};
        }
        return response.json();
      })
      .then(json => {
        this.setState({
          formStatus: formStatuses.SUCCESS,
          submitting: false
        });

        console.log("response", json);
      })
      .catch(error => {
        console.log("generic error", error);
        this.setState({
          formStatus: formStatuses.GENERIC_ERROR,
          submitting: false
        });
      });
  }

  handleFieldChange({ name, groupID, value, isValid }) {
    this.setState(prevState => ({
      ...prevState,

      formData: {
        ...prevState.formData,

        [groupID || name]:
          groupID === null
            ? value
            : {
                ...prevState.formData[groupID],

                [name]: value
              }
      },
      validation: {
        ...prevState.validation,

        [name]: isValid
      }
    }));
  }

  renderTitle() {
    return (
      <div className="row">
        <div className="col-12 col-sm-9 margin-bottom-80">
          <Translator>
            {t => (
              <h2 className="font-tt3 margin-bottom-32">
                {t("v2_contacts-title-1")}
              </h2>
            )}
          </Translator>
          {this.renderMessage()}
        </div>
      </div>
    );
  }

  renderMessage() {
    const { formStatus } = this.state;
    const isSucceed = formStatus === formStatuses.SUCCESS;

    if (isSucceed) {
      return (
        <Translator>
          {t => (
            <span className="font-mini-spacemono font-color-grey">
              {t("v2_contacts-confirmation-a")}
              <br />
              <br />
              {t("v2_contacts-confirmation-b")}
            </span>
          )}
        </Translator>
      );
    }

    return (
      <Translator>
        {t => (
          <span className="font-mini-spacemono font-color-grey">
            {t("v2_contacts-subtitle-1")}
          </span>
        )}
      </Translator>
    );
  }

  renderFormFields() {
    const { submitting, formStatus } = this.state;
    const isSucceed = formStatus === formStatuses.SUCCESS;

    return (
      !isSucceed &&
      fieldsBySections.map((section, i) => {
        if (section.withFieldset) {
          return (
            <fieldset disabled={submitting} key={i}>
              <div className="row">
                {section.fields.map(field => (
                  <FormField
                    key={field.name}
                    field={field}
                    handleFieldChange={this.handleFieldChange}
                  />
                ))}
              </div>
            </fieldset>
          );
        } else {
          return (
            <div className="row" key={i}>
              <Translator>
                {t => (
                  <div className="col-12 margin-bottom-32">
                    <h3 className="font-tp6">{t(section.title)}</h3>
                    <a className={styles.inlineLink} />
                    <Paragraph
                      className="font-micro"
                      text={t(section.info,'', { CLASSNAME: styles.inlineLink })}
                    />
                  </div>
                )}
              </Translator>
            </div>
          );
        }
      })
    );
  }

  renderFormSubmit() {
    const { submitting, validation, formStatus } = this.state;
    const invalid = Object.values(validation).includes(false);
    const isSucceed = formStatus === formStatuses.SUCCESS;

    return (
      !isSucceed && (
        <Translator>
          {t => (
            <input
              type="submit"
              value={t("v2_contacts-cta")}
              disabled={submitting || invalid}
              className="font-body"
            />
          )}
        </Translator>
      )
    );
  }

  render() {
    const { contactFormOpen, closePanel } = this.props;

    return (
      <CSSTransition
        appear
        in={contactFormOpen}
        timeout={{ appear: 150, enter: 150, exit: 300 }}
        classNames={{
          appear: styles.enter,
          appearActive: styles.enterActive,
          appearDone: styles.open,
          enter: styles.enter,
          enterActive: styles.enterActive,
          enterDone: styles.open,
          exit: styles.exit,
          exitActive: styles.exitActive
        }}
        unmountOnExit
        mountOnEnter
      >
        <div
          className={c(styles.ContactForm)}
          onScroll={e => e.stopPropagation()}
        >
          <div
            className={c(
              styles.formSide,
              " d-flex",
              "aligns-items-center",
              "justify-content-center"
            )}
          >
            <svg
              onClick={closePanel}
              className={styles.closeSvg}
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <defs>
                <path
                  id="closeSvg"
                  d="M7.06 6l4.42 4.419a.75.75 0 0 1-1.061 1.06L6 7.062 1.581 11.48a.75.75 0 0 1-1.06-1.061L4.938 6 .52 1.58A.75.75 0 0 1 1.58.52L6 4.94 10.42.52a.75.75 0 0 1 1.06 1.06L7.06 6z"
                />
              </defs>
              <g fill="none" fillRule="evenodd">
                <path d="M0 24h24V0H0z" />
                <g transform="translate(6 6)">
                  <mask id="closeSvgMask" fill="#fff">
                    <use xlinkHref="#closeSvg" />
                  </mask>
                  <use
                    fill="#BF2A2A"
                    fillRule="nonzero"
                    xlinkHref="#closeSvg"
                  />
                  <g fill="#2B2B2B" mask="url(#closeSvgMask)">
                    <path d="M-6-6h24v24H-6z" />
                  </g>
                </g>
              </g>
            </svg>

            <form
              onSubmit={this.handleSubmit}
              className={c(styles.submitApplicationForm)}
            >
              {this.renderTitle()}

              {this.renderFormFields()}

              {this.renderFormSubmit()}
            </form>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm/template.js